// src/components/SomeComponent.tsx
import React, { useContext } from "react";
import { SettingsContext } from "../context/SettingsContext";

const SettingsPage: React.FC = () => {
    const { settings, loading, error } = useContext(SettingsContext);

    if (loading) return <div>Loading settings...</div>;
    if (error) return <div>{error}</div>;

    return (
        <div>
            <h2>Professions</h2>
            <ul>
                {settings?.professions.map((profession) => (
                    <li key={profession.id}>{profession.professionName}</li>
                ))}
            </ul>

            <h2>Worker Statuses</h2>
            <ul>
                {settings?.workerStatuses.map((status, index) => (
                    <li key={index}>{status}</li>
                ))}
            </ul>

            <h2>Availability Statuses</h2>
            <ul>
                {settings?.availabilityStatuses.map((status, index) => (
                    <li key={index}>{status}</li>
                ))}
            </ul>
        </div>
    );
};

export default SettingsPage;
